import { render, staticRenderFns } from "./join-style.vue?vue&type=template&id=abd83ddc&scoped=true&"
import script from "./join-style.vue?vue&type=script&lang=js&"
export * from "./join-style.vue?vue&type=script&lang=js&"
import style0 from "./join-style.vue?vue&type=style&index=0&id=abd83ddc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abd83ddc",
  null
  
)

export default component.exports